
// src/components/Register/styles.ts
import styled from 'styled-components';
import { Box, Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const StyledRightButton = styled(Button)`
  fontFamily: 'IRANYekanXFaNum',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'none',
  width: '140px',
  height: '40px',
  borderRadius: '4px',
  border: '1px solid #bdbdc0',
  padding: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  color: 'red',
  backgroundColor: blue,
  transition: 'background-color 0.3s',
  
  '&:hover': {
    backgroundColor: '#bdbdc0', // Darker shade on hover
  
`;

export const ContentBox = styled(Box)`
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  gap: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: auto; 
  @media (max-width: 768px) {
    max-width: 350px; 
  }
`;

export const SuBox = styled(Box)`
  background-color: #FFFFFF;
  border-radius: 8px;
  justify-content: center;
  width: 100%;
  display: flex;
`;

// export const ApproveLabel = styled.label`
//   color: #1E88E5; 
//   font-size: 14px; 
//   font-family: 'IRANYekanXFaNum'; 
//   font-weight: 700; 
//   text-align: center; 
//   margin: 20px 0 16px 2px; 
//   line-height:16px;
// `;

export const ApproveLabel = styled.label`
  color: #1E88E5; /* Blue color similar to the button */
  font-size: 14px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 700;
  text-align: center;
  margin: 20px 0 16px 2px;
  line-height: 16px;
  cursor: pointer;
  display: inline-block; 
  
 
  &:hover {
    text-decoration: underline; /* Underline when hovered */
    color: #0d6efd; /* Darker shade of blue */
  }
  
  /* Add focus effect if needed for accessibility */
  &:focus {
    outline: 2px solid #1E88E5; /* Focus ring around the label */
    outline-offset: 2px;
  }
`;

export const LinkContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 1px;
`;

export const ClickableText = styled.span`
  cursor: pointer;
  color: #60646E; 
  font-size: 12px; 
  font-family: 'IRANYekanXFaNum'; 
  font-weight: 500; 
  &:hover {
    text-decoration: underline; 
  }
`;


export const Divider = styled.hr`
  width: 100%;
  border: 0.5px solid #ccc; 
  margin: 16px 0; 
  border: 1px #D9D9DD dotted;
  margin: 2px 0 12px 20px; 
`;

export const SubTitle = styled.h6`
  margin: 2px 0 12px 12px; 
  color: #35373C;
  font-size: 14px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 500;
  line-height: normal;
  text-align: right;
  
`;

export const Title = styled.div`
  color: White & Black/10;
  font-size: 20px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 900;
  margin: 2px 0 12px 20px;
  text-align: right;
  line-height: 26px;
`;

export const Content = styled(Box)`
 flex-direction: row;
  color: White & Black/11;
  font-size: 16px;
  font-family: 'IRANYekanXFaNum';
  font-weight: 600;
  margin: 2px 0 12px 20px;
  text-align: right;
  line-height: 18.2px;
  align-items: right;
`;

// Styled clickable box with a dotted border
export const DetailsBox = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 360px;
  height: 84px;
  background-color: #f9f9f9;
  border: 2px solid #FFC8A9;
  border-radius: 4px;
  align-items: center; /* Vertically center content */
  justify-content: space-between; /* Space between items horizontally */
  padding: 16px;
  @media (max-width: 768px) {
    max-width: 310px;
  }
`;

export const FooterApprove = styled.label`
display: flex;
  flex-direction: row;
  width: 360px;
  height: 84px;
  
  border-radius: 4px;
  align-items: center; /* Vertically center content */
  justify-content: space-between; /* Space between items horizontally */
  @media (max-width: 768px) {
    max-width: 310px;
  }
  
`;

export const FooterBand = styled.label`
display: flex;
  flex-direction: row;
  width: 360px;
  height: 84px;
  align-items: left; /* Vertically center content */
  justify-content: space-between; /* Space between items horizontally */
  @media (max-width: 768px) {
    max-width: 310px;
  }
  
`;

export const SuccessBox = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 360px;
  height: 84px;
  background-color: #FFFFFF;
  border: 2px solid #DBFFF0;
  border-radius: 4px;
  align-items: center; /* Vertically center content */
  justify-content: space-between; /* Space between items horizontally */
  padding: 16px;
  @media (max-width: 768px) {
    max-width: 310px;
  }
`;

export const CancelBox = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 360px;
  height: 84px;
  background-color: #FFFFFF;
  border: 2px solid #FFD6DB;
  border-radius: 4px;
  align-items: center; /* Vertically center content */
  justify-content: space-between; /* Space between items horizontally */
  padding: 16px;
  @media (max-width: 768px) {
    max-width: 310px;
  }
`;

export const PendingButton = styled.div`
  display: flex;
  justify-content: left;
`;
const useStyles = makeStyles({
  primaryText: {
    fontFamily: 'IRANYekanXFaNum',
    fontSize: '16px',
    fontWeight: 700,
    color: '#35373C',
    lineHeight: '20.8px',
    textAlign: 'right',
  },
});

export default useStyles;
export const SecondaryTextA = styled(Typography)({
  fontFamily: 'IRANYekanXFaNum',
  fontSize: 16,
  color: '#FF833D',
  backgroundColor: '#FFE3D3',
  fontWeight: 700,
  lineHeight: 20.8,
  textAlign: 'right',
  paddingRight: 4,
  paddingLeft: 4,
  
 
});

export const SecondaryTextB = styled(Typography)({
  fontFamily: 'IRANYekanXFaNum',
  fontSize: 16,
  color: '#1E88E5',
  backgroundColor:  '#BBC0CB',
  fontWeight: 700,
  lineHeight: 20.8,
  textAlign: 'right',
  paddingRight: 4,
  paddingLeft: 4,
 
});

export const AdditionalInfoText = styled.h6`
  font-family: 'IRANYekanXFaNum';
  font-size: 11px; /* Remove quotes */
  color: #60646E;
  font-weight: 500;
  line-height: 15.6px; 
  text-align: center;
  padding-left: 0px; /* Remove quotes */
  padding-right: 0px; /* Remove quotes */
`;



export const TextRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px', // Spacing between text and icon
});
